// extracted by mini-css-extract-plugin
export default {"hotelLine":"hotelRelink-module__hotelLine__EWdZ3","hotelTitle":"hotelRelink-module__hotelTitle__I4a5k","container":"hotelRelink-module__container__D0kVh"};